import { gql } from '@apollo/client';

export const GET_CLIENT_PORTAL_DATA = gql`
  query BaseProjectClientPortal($id: ID!) {
    baseProject(id: $id) {
      id
      clientPortal {
        projectId
        projectName
        accountAlias
        users {
          id
          email
          externalId
          firstName
          lastName
          name
          status
          invitedAt
          accessUntil
          lastLoginAt
        }
        requestedUsers {
          id
          email
          firstName
          lastName
          name
          status
          accessUntil
        }
        tasks {
          id
          alias
          projectId
          accountAlias
          type
          title
          clientTaskLink
          assigneeExternalUserId
          dueDate
          description
          attachments {
            id
            fileName
            contentType
            size
            uploadedAt
          }
          responseAttachments {
            id
            fileName
            contentType
            size
            uploadedAt
          }
          status
          responseNote
          responseLink
          cancelReason
        }
        taskComments {
          taskId
          comments {
            id
            taskId
            authorId
            authorName
            authorType
            createdAt
            text
            updatedAt
            isResolved
            resolvedAt
            resolvedBy
            replies {
              id
              taskId
              authorId
              authorName
              authorType
              createdAt
              updatedAt
              text
            }
          }
        }
        taskActivities {
          taskId
          activities {
            id
            taskId
            action
            externalUserId
            externalUserName
            createdAt
          }
        }
      }
      accessInfo {
        id
        sections {
          section
          allowedActions
        }
      }
    }
  }
`;
